import React from 'react';
import { Grid, Button, IconButton } from '@mui/material';
import * as Icon from '@mui/icons-material';

interface ItensTableProps {
  values: any;
  handleOpenItensModal: () => void;
  setFieldValue: any
  duploClick?: boolean;
  edicaoRestrita: boolean;
}

const OrdemServicoItens: React.FC<ItensTableProps> = ({ values, handleOpenItensModal, setFieldValue, duploClick, edicaoRestrita }) => {

  const handleRemoveItem = (index: number) => {
    const updatedItensJson = values.itensJson.filter((_: any, i: any) => i !== index);
    setFieldValue('itensJson', updatedItensJson);
  };

  const handleEditItem = (index: number) => {
    console.log(index)
    const selectedItem = values.itensJson[index];
    console.log(selectedItem)
    setFieldValue('selectedItem', selectedItem);
    handleOpenItensModal();
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{ width: '80%', margin: '0 auto' }}
    >
      <Grid item xs={12}>
        <fieldset disabled={duploClick || edicaoRestrita}>
          <Button
            variant='contained'
            color='primary'
            onClick={handleOpenItensModal}
            sx={{ mb: 2 }}
          >
            Adicionar Item
          </Button>
        </fieldset>
      </Grid>
      <Grid item xs={12}>
        <fieldset disabled={duploClick || edicaoRestrita}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th
                  style={{ border: '1px solid #ccc', padding: '8px' }}
                >
                  Produto
                </th>
                <th
                  style={{ border: '1px solid #ccc', padding: '1px' }}
                >
                  Quantidade
                </th>
                <th
                  style={{ border: '1px solid #ccc', padding: '8px' }}
                >
                  Marca
                </th>
                <th
                  style={{ border: '1px solid #ccc', padding: '8px' }}
                >
                  Modelo
                </th>
                <th
                  style={{ border: '1px solid #ccc', padding: '8px' }}
                >
                  Nº. Série
                </th>
                <th
                  style={{ border: '1px solid #ccc', padding: '8px' }}
                >
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              {values.itensJson.map((item: any, index: any) => (
                <tr key={index}>
                  <td
                    style={{ border: '1px solid #ccc', padding: '8px' }}
                  >
                    {item?.item?.produto}
                  </td>
                  <td
                    style={{ border: '1px solid #ccc', padding: '8px' }}
                  >
                    {item?.item?.quantidade}
                  </td>
                  <td
                    style={{ border: '1px solid #ccc', padding: '8px' }}
                  >
                    {item?.item?.prod_marca}
                  </td>
                  <td
                    style={{ border: '1px solid #ccc', padding: '8px' }}
                  >
                    {item?.item?.prod_modelo}
                  </td>
                  <td
                    style={{ border: '1px solid #ccc', padding: '8px' }}
                  >
                    {item?.item?.prod_numSerie}
                  </td>
                  <td
                    style={{ border: '1px solid #ccc', padding: '8px' }}
                  >
                    <IconButton
                      onClick={() => handleEditItem(index)}
                      aria-label='edit'
                      color='info'
                      title='Editar'
                      disabled={duploClick || edicaoRestrita}
                    >
                      {' '}
                      <Icon.Edit />
                    </IconButton>
                    <IconButton
                      color='error'
                      onClick={() => handleRemoveItem(index)}
                      disabled={duploClick || edicaoRestrita}
                    >
                      <Icon.Delete />
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </fieldset>
      </Grid>
    </Grid>
  );
}

export default OrdemServicoItens;
